import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { AudioRecorderSTT } from '../audio-recorder';
import { useSelector } from 'react-redux';
import AsrSTT from '../asr/AsrSTT';

const CardSTT = () => {
    const response = useSelector((state) => state.ecChat.response);
    const greeting = response === "" ? "ইলেকশন কমিশন চ্যাট বট এ আপনাকে স্বাগতম। কিভাবে আপনার সাহায্য করতে পারি?" : response;
    const dialPad = useSelector((state) => state.ecChat.dialPad);
    const [dialPadText, setDialPadText] = useState("");
    const dialPadTest = response === "" ? false : true;

    return (
        <Container style={{"background": "#f1f1f0"}}>
            <Row>
                <Col>
                    <div className="card-default">
                        <div>
                            <AudioRecorderSTT />
                            <AsrSTT />
                            {/* <h3>{greeting}</h3>
                            <ECAsrChat />
                            {dialPadTest && <DialPad />}
                            <ECChatReply />             */}
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default CardSTT;